import axios from 'axios'
import dictionariesList from '@utils/dictionaries-list'
import { getDocumentTypeId } from '@utils/transformations'
import * as compare from '@utils/comparers'
import * as api from '../../utils/api'

export const state = {
  dictionariesIsLoaded: false,
  dictionaries: {
    addresstype: [],
    alertanalyzersettings: [],
    characteristic: [],
    city: [],
    communicationtype: [],
    contact: [],
    contactstatus: [],
    contactcommunication: [],
    density: [],
    documenttype: [],
    documentstatus: [],
    event: [],
    goods: [],
    goodscharacteristic: [],
    goodsgroup: [],
    goodsstatus: [],
    operationtype: [],
    organization: [],
    organizationaddress: [],
    orgcommunication: [],
    organizationstatus: [],
    organizationtype: [],
    plugcomstatus: [],
    userstatus: [],
    devices: [],
    devicesmergedshipped: [],
    region: [],
    remain: [],
    role: [],
    unit: [],
    user: [],
    deliverytype: [],
    sex: [{ code: true, name: 'Male' }, { code: false, name: 'Female' }],
    boolean: [{ code: true, name: 'true' }, { code: false, name: 'false' }],
    wakeupReason: [],
    workshops: [],
    warehouses: [],
    measureType: [],
    corrections: [],
    sending: [],
  },
  myOrganization: null,
}

export const getters = {
  dictionariesIsLoaded(state) {
    return state.dictionariesIsLoaded
  },
  getValueFromDictionary: state => (dictionaryName, value) => {
    try {
      switch (dictionaryName) {
        case 'workshops':
        case 'warehouses':
        case 'organization':
        case 'goods':
          return state.dictionaries[dictionaryName].find(x => x.id === value)
            .shortName
        case 'user':
          const user = state.dictionaries[dictionaryName].find(
            x => x.id === value
          )
          return `${user.firstName} ${user.lastName}`
        case 'unit':
          return state.dictionaries[dictionaryName].find(x => x.code === value)
            .shortName
        default:
          return state.dictionaries[dictionaryName].find(x => x.code === value)
            .name
      }
    } catch (ex) {
      return value
    }
  },
  getItemFromDictionary: state => (dictionaryName, value) => {
    try {
      switch (dictionaryName) {
        case 'documenttype':
        case 'documentstatus':
        case 'operationtype':
        case 'userstatus':
        case 'contactstatus':
        case 'communicationtype':
        case 'goodsgroup':
          return state.dictionaries[dictionaryName].find(x => x.code === value)
        case 'organization':
        case 'goods':
        case 'user':
        case 'contact':
          return state.dictionaries[dictionaryName].find(
            x => x.id === Number(value)
          )
        case 'unit':
          return state.dictionaries[dictionaryName].find(x => x.code === value)
        default:
          return value
      }
    } catch (ex) {
      return value
    }
  },
  getOrganization: state => {
    if (!state.dictionaries.organization) return null
    return state.dictionaries.organization
      .filter(x => x.type !== 1)
      .sort(compare.byShortName)
  },
  getAllOrganizations: state => {
    if (!state.dictionaries.organization) return null
    return state.dictionaries.organization
  },
  getWorkshopsFromOrganizations: state => {
    if (!state.dictionaries.organization) return null
    return state.dictionaries.organization.filter(x => x.type === 3)
  },
  getWarehouses: state => {
    if (!state.dictionaries.organization) return null
    return state.dictionaries.organization
      .filter(x => x.type === 1)
      .sort(compare.byShortName)
  },
  getDefaultOrganizationList: state => {
    if (!state.dictionaries.organization) return null
    return state.dictionaries.organization
      .filter(x => x.type === 2 || x.type === 4)
      .sort(compare.byShortName)
  },
  getWarehousesWithDevices: state => {
    return state.dictionaries.warehouses
  },
  getWorkshops: state => {
    return state.dictionaries.workshops
  },
  getDevices: state => {
    return state.dictionaries.devices
  },
  getGoods: state => documentType => {
    const goods = state.dictionaries.goods
    switch (documentType) {
      case 1:
        return goods
          .filter(x => x.group === 2 || x.group === 3)
          .sort(compare.byShortName)
      case 2:
        return goods
          .filter(x => x.group === 3 || x.group === 5)
          .sort(compare.byShortName)
      case 4:
        return goods.filter(x => x.group === 5).sort(compare.byShortName)
      case 5:
      case 6:
        return goods
          .filter(x => x.group === 3 || x.group === 5 || x.group === 2)
          .sort(compare.byShortName)
      default:
        return goods.slice(0).sort(compare.byShortName)
    }
  },
  getGoodsByGroup: state => group => {
    if (!state.dictionaries.goods) return null
    return state.dictionaries.goods
      .filter(x => x.group === group)
      .sort(compare.byShortName)
  },
  getDictionary: state => dictionaryName => {
    if (!state.dictionaries[dictionaryName][0]) return
    const comparerBy = compare.defineComparer(
      state.dictionaries[dictionaryName][0]
    )
    return state.dictionaries[dictionaryName].slice(0).sort(compare[comparerBy])
  },
  getOil: state => {
    if (!state.dictionaries.goods) return null
    return state.dictionaries.goods
      .filter(x => x.group === 1)
      .sort(compare.byShortName)
  },
  getDrum: state => {
    if (!state.dictionaries.goods) return null
    return state.dictionaries.goods
      .filter(x => x.group === 4)
      .sort(compare.byShortName)
  },
  getDeliveryType: state => {
    if (!state.dictionaries.organization) return null
    return state.dictionaries.deliverytype
  },
}

export const mutations = {
  SET_DICTIONARY(state, payload) {
    state.dictionaries[payload.name] = payload.data
  },
  SET_MY_ORGANIZATION(state, payload) {
    state.myOrganization = payload
  },
  SET_DICTIONARY_LOADING_STATUS(state, payload) {
    state.dictionariesIsLoaded = payload
  },
}

export const actions = {
  async getAllDictionaries({ commit, dispatch }) {
    const requests = []
    for (let item of dictionariesList) {
      requests.push(dispatch('fetchDictionary', item))
    }
    await Promise.all(requests).catch(error => {
      return Promise.reject(error)
    })
    commit('SET_DICTIONARY_LOADING_STATUS', true)
    // Всегда Bizoil
    // await axios.get('/api/1/myorganization/getMy').then(response => {
    //   commit('SET_MY_ORGANIZATION', response.data.id)
    // })
    await commit('SET_MY_ORGANIZATION', 1)
    return true
  },
  fetchDictionary({ commit }, payload) {
    if (
      payload !== 'devices' &&
      payload !== 'devicestatuses' &&
      payload !== 'organization' &&
      payload !== 'region' &&
      payload !== 'constants'
    ) {
      return axios
        .get(`/api/1/${payload}`, {
          params: {
            size: 10000,
          },
        })
        .then(response => {
          commit('SET_DICTIONARY', {
            name: payload,
            data: response.data.content,
          })
        })
    }
    if (payload === 'organization') {
      return axios
        .get(`/api/1/organization/all`, { params: { size: 10000 } })
        .then(response => {
          commit('SET_DICTIONARY', {
            name: payload,
            data: response.data.content,
          })
        })
    }
    if (payload === 'region') {
      return axios
        .get(`/api/1/region/all`, { params: { size: 10000 } })
        .then(response => {
          commit('SET_DICTIONARY', {
            name: payload,
            data: response.data.content,
          })
        })
    }
    if (payload === 'constants') {
      commit('SET_DICTIONARY', {
        name: 'wakeupReason',
        data: [
          { code: 0, name: 'wakeup first' },
          { code: 1, name: 'wakeup by timer' },
          { code: 2, name: 'wakeup by user button' },
          { code: 3, name: 'wakeup by alarm button' },
        ],
      })
      commit('SET_DICTIONARY', {
        name: 'measureType',
        data: [
          { code: 0, name: 'measure short' },
          { code: 1, name: 'measure normal' },
          { code: 2, name: 'measure full' },
          { code: 3, name: 'measure error' },
        ],
      })
      commit('SET_DICTIONARY', {
        name: 'corrections',
        data: [
          { code: 0, name: 'no correction' },
          { code: 1, name: 'corrected' },
          { code: 2, name: 'its correction' },
          { code: 3, name: 'its corr replica' },
        ],
      })
      commit('SET_DICTIONARY', {
        name: 'sending',
        data: [
          { code: 0, name: 'was sent' },
          { code: 1, name: 'not sent no network' },
          { code: 2, name: 'not sent sending error' },
          { code: 3, name: 'not sent skipped' },
        ],
      })
    }
    if (payload === 'devicestatuses') {
      return axios
        .get(`/api/1/warehouse/devicestatuses`)
        .then(response => {
          commit('SET_DICTIONARY', {
            name: payload,
            data: response.data,
          })
        })
        .catch(error => {
          console.error(error)
        })
    } else {
      api
        .getItems('warehouse/devices', {
          size: 10000,
          page: 1,
        })
        .then(devices => {
          commit('SET_DICTIONARY', {
            name: payload,
            data: devices,
          })
        })
    }
  },
  fetchWarehouses({ commit }, payload) {
    return axios
      .get('/api/1/workshops', modifyRequestParams(payload, false, 1))
      .then(response => {
        commit('SET_DICTIONARY', {
          name: 'warehouses',
          data: response.data.content,
        })
        return response.data
      })
  },
  fetchWorkshops({ commit }, payload) {
    return axios
      .get('/api/1/workshops', modifyRequestParams(payload, false, 3))
      .then(response => {
        commit('SET_DICTIONARY', {
          name: 'workshops',
          data: response.data.content,
        })
        return response.data
      })
  },
  fetchDevices({ commit }, { payload, organizationId = null }) {
    const endpointPath = organizationId
      ? `/api/1/devices/organisation/${organizationId}`
      : '/api/1/devices'

    return axios
      .get(endpointPath, modifyRequestParams(payload, false))
      .then(response => {
        commit('SET_DICTIONARY', {
          name: 'devices',
          data: response.data.content,
        })
        return response.data
      })
  },
  updateDictionary({ dispatch }, payload) {
    dispatch('fetchDictionary', payload)
  },
  fetchData({ state, commit }, payload) {
    const params = {
      filter_type_value: payload.name ? getDocumentTypeId(payload.name) : null,
      ...payload.params,
      filter_type_comparison: 'EQ',
      size: payload.params.size,
      page: payload.params.page - 1,
      sort_property: modifySortProperty(payload.params.sort_property),
      sort_direction: payload.params.sort_direction ? 'DESC' : 'ASC',
    }
    return axios.get('/api/1/document', { params }).then(response => {
      return response.data
    })
  },
}

/* Helpers */
function modifySortProperty(property) {
  switch (property) {
    case 'from':
      return 'from.shortName'
    case 'fromWarehouse':
      return 'fromWarehouse.shortName'
    case 'to':
      return 'to.shortName'
    case 'toWarehouse':
      return 'toWarehouse.shortName'
    case 'parent':
      return 'parent.shortName'
    case 'city':
      return 'city.name'
    case 'type':
      return 'type.name'
    default:
      return property
  }
}

function modifyRequestParams(payload, withModify = true, type) {
  const params = {
    ...payload.params,
    filter_type_comparison: 'EQ',
    size: payload.params.size,
    page: payload.params.page - 1,
    sort_property: withModify
      ? modifySortProperty(payload.params.sort_property)
      : payload.params.sort_property,
    sort_direction: payload.params.sort_direction ? 'DESC' : 'ASC',
  }
  if (type) {
    params['filter_type_value[]'] = type
  }
  return { params }
}
